// Public marketing routes, grouped. Drives footer links, "More" blocks, and keeps
// src/App.jsx, scripts/prerender.mjs and public/sitemap.xml easy to cross-check.

export const GUIDES = [
  { path: '/website-feedback-tool', name: 'Website feedback tool' },
  { path: '/website-annotation-tool', name: 'Website annotation tool' },
  { path: '/how-it-works', name: 'How it works' },
  { path: '/compatibility', name: 'Platform compatibility' },
];

export const PLATFORMS = [
  { slug: 'wordpress', name: 'WordPress' },
  { slug: 'shopify', name: 'Shopify' },
  { slug: 'webflow', name: 'Webflow' },
  { slug: 'squarespace', name: 'Squarespace' },
  { slug: 'wix', name: 'Wix' },
  { slug: 'nextjs', name: 'Next.js' },
];

export const COMPARISONS = [
  { slug: 'marker-io', name: 'Marker.io' },
  { slug: 'bugherd', name: 'BugHerd' },
  { slug: 'userback', name: 'Userback' },
  { slug: 'usersnap', name: 'Usersnap' },
  { slug: 'pastel', name: 'Pastel' },
  { slug: 'ruttl', name: 'Ruttl' },
  { slug: 'markup-io', name: 'Markup.io' },
  { slug: 'feedbucket', name: 'Feedbucket' },
];
